import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../modules/utils/constants/constants';

export const StyledFilterContainerDiv = styled.div`
  margin: 10px;
`;

export const GlobalStyle = createGlobalStyle`
  .spinner-wrapper {
    display: none !important;
  }
`;

export const GlobalUnsetMinHeight = createGlobalStyle`
  body {
    overflow: hidden;
  }

  .search-page-container {
    min-height: unset !important;
  }

  #universal-footer {
    display: none;
  }
`;

export const GlobalScrollIOS = createGlobalStyle`
  body {
    position: fixed;
    left: 0;
    right: 0;
  }
`;

export const StyledSearchResultContainer = styled.div<{ windowHeight: number; offsetHeight: number }>`
  background-color: ${baseVariables.color.neutral10};

  .map-view-container {
    &__parent {
      position: relative;
      background-color: ${baseVariables.color.base20};
      height: ${props => `${Math.max(0, Math.round((props?.windowHeight || 0) - (props?.offsetHeight || 0)))}px`};
      overflow: hidden;
    }

    &__map-hide {
      display: none;

      @media ${baseVariables.mediaQuery.xl} {
        display: unset;
      }
    }

    &__map {
      position: relative;
      width: 100%;

      .gm-style-iw-chr {
        display: none;
      }

      .gm-style-iw,
      .gm-style-iw-c {
        padding: 0;
      }

      .gm-style-iw-d {
        overflow: visible !important;
      }

      .gm-style-iw-tc {
        &::after {
          height: ${toRem(10)};
          left: ${toRem(6)};
          width: ${toRem(18)};
        }
      }

      .toggle-sidebar {
        border-radius: 0;
        position: absolute;
        top: ${toRem(32)};
        background-color: rgb(255, 255, 255);
        left: 0;
        z-index: 1;
        padding: ${toRem(8)} ${toRem(8)} ${toRem(8)} ${toRem(4)};
        border-top-right-radius: ${toRem(99)};
        border-bottom-right-radius: ${toRem(99)};

        span {
          display: block;
          width: ${toRem(24)};
          height: ${toRem(24)};
        }
        span:before {
          padding-right: 0;
          font-size: ${toRem(24)};
          line-height: ${toRem(24)};
        }
      }

      .toggle-sidebar-hide {
        display: none;

        @media ${baseVariables.mediaQuery.xl} {
          display: unset;
        }
      }
    }

    &__search-outlets {
      min-width: ${toRem(380)};
      width: ${toRem(380)};
      overflow-y: scroll;
      box-shadow: 0px ${toRem(7)} ${toRem(20)} 0px rgba(0, 0, 0, 0.25);
      // border-right: 1px solid rgba(238, 238, 238, 1);
      display: none;

      @media ${baseVariables.mediaQuery.xl} {
        display: unset;
      }

      ::-webkit-scrollbar {
        width: ${toRem(8)};
      }

      ::-webkit-scrollbar-track {
        background: ${baseVariables.color.base20};
        border-radius: ${toRem(4)};
        margin: ${toRem(30)} 0 ${toRem(80)};
      }

      ::-webkit-scrollbar-thumb {
        background-color: ${baseVariables.color.neutral20};
        border-radius: ${toRem(4)};
        height: ${toRem(150)};
        background-clip: unset;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: ${baseVariables.color.neutral40} !important;
      }

      .property-card__img-container,
      .property-card__img-container--img {
        width: 100%;
        height: ${toRem(228)};
      }

      .pagination-container {
        background: ${baseVariables.color.base20};
        position: sticky;
        bottom: 0;
        box-shadow: 0px ${toRem(7)} ${toRem(20)} 0px #00000040;
        z-index: 2;

        .rnb-pagination-container,
        .rnb-pagination-container > ul {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
    }
  }

  .list-cta-mobile {
    position: absolute;
    bottom: ${toRem(24)};
    z-index: 1;
    left: 0;
    right: 0;

    @media ${baseVariables.mediaQuery.md} {
      display: none;
    }
  }

  .list-cta-desktop {
    display: none;
    @media ${baseVariables.mediaQuery.md} {
      display: block;
    }
  }

  .search-cta-container {
    position: absolute;
    z-index: 1;
    right: 0;
    top: ${toRem(24)};
    right: ${toRem(24)};
    column-gap: ${toRem(8)};
  }

  .map-cta {
    position: sticky;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 2;
    width: fit-content;
    margin: auto;
  }

  .cta-container {
    .map-button {
      box-shadow: 0px ${toRem(7)} ${toRem(20)} 0px rgba(0, 0, 0, 0.25);

      &:focus,
      &:active {
        border: 0.0625rem solid rgb(0, 0, 0);
      }
    }
  }

  .current-location-button {
    box-shadow: 0px ${toRem(7)} ${toRem(20)} 0px rgba(0, 0, 0, 0.25);
    outline: none;

    &:focus,
    &:active,
    &:hover {
      outline: none;
    }

    span {
      font-size: ${toRem(24)};

      &:before {
        padding-right: 0;
        font-size: ${toRem(24)};

        @media ${baseVariables.mediaQuery.md} {
          padding-right: ${toRem(10)};
          font-size: ${toRem(16)};
        }
      }

      @media ${baseVariables.mediaQuery.md} {
        font-size: ${toRem(16)};
      }
    }
  }

  .rnb-error-container {
    display: none;

    @media ${baseVariables.mediaQuery.xl} {
      width: auto;
      display: block;
    }
  }

  .property-card__details-container {
    height: calc(100% - 50%);
  }

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    .property-card__details-container {
      height: inherit;
    }
  }

  ${rtl`
    &:is(${constants.RTL_LANG_LIST}) {
      .pagination-details {
        direction: ltr;
      }
    }
    .rnb-pagination-arrow {
      &.disabled {
        pointer-events: none;
        opacity: 0.3;
      }
  `}
`;
